import { render, staticRenderFns } from "./floorvalue.vue?vue&type=template&id=9d28e096&"
import script from "./floorvalue.vue?vue&type=script&lang=js&"
export * from "./floorvalue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9d28e096')) {
      api.createRecord('9d28e096', component.options)
    } else {
      api.reload('9d28e096', component.options)
    }
    module.hot.accept("./floorvalue.vue?vue&type=template&id=9d28e096&", function () {
      api.rerender('9d28e096', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2WNT4Q0TDzfUf/JS/comp/floorvalue.vue"
export default component.exports